import { render, staticRenderFns } from "./ListClassificacao.vue?vue&type=template&id=4922f172"
import script from "./ListClassificacao.vue?vue&type=script&lang=js"
export * from "./ListClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports